import { createSlice } from '@reduxjs/toolkit'
import { AxiosError } from '@src/helpers/httpClient'

import {
  GLOBAL_STATE,
  PRE_MODERATION_ALL,
  PRE_MODERATION_ASSIGNED,
  PRE_MODERATION_BY_ID,
  PRE_MODERATION_CHANGE_STATUS,
  PRE_MODERATION_HISTORY_CREATE,
} from '../constants/actionTypes'
import * as actionCreators from './actions'
import { defaultState, initialState } from './initialState'

export const PRE_MODERATION = GLOBAL_STATE

export const { reducer: preModerationReducer } = createSlice({
  name: PRE_MODERATION,
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(actionCreators.preModerationAll.pending, state => {
        state[PRE_MODERATION_ALL].loading = true
      })
      .addCase(actionCreators.preModerationAll.rejected, (state, action) => {
        state[PRE_MODERATION_ALL].loading = false
        state[PRE_MODERATION_ALL].error = action.payload as AxiosError
      })
      .addCase(actionCreators.preModerationAll.fulfilled, (state, action) => {
        state[PRE_MODERATION_ALL].loading = false
        state[PRE_MODERATION_ALL].error = null
        state[PRE_MODERATION_ALL].data = action.payload
      })

    builder
      .addCase(actionCreators.preModerationAssigned.pending, state => {
        state[PRE_MODERATION_ASSIGNED].loading = true
      })
      .addCase(actionCreators.preModerationAssigned.rejected, (state, action) => {
        state[PRE_MODERATION_ASSIGNED].loading = false
        state[PRE_MODERATION_ASSIGNED].error = action.payload as AxiosError
      })
      .addCase(actionCreators.preModerationAssigned.fulfilled, (state, action) => {
        state[PRE_MODERATION_ASSIGNED].loading = false
        state[PRE_MODERATION_ASSIGNED].error = null
        state[PRE_MODERATION_ASSIGNED].data = action.payload
      })

    builder
      .addCase(actionCreators.preModerationById.pending, state => {
        state[PRE_MODERATION_BY_ID].loading = true
      })
      .addCase(actionCreators.preModerationById.rejected, (state, action) => {
        state[PRE_MODERATION_BY_ID].loading = false
        state[PRE_MODERATION_BY_ID].error = action.payload as AxiosError
      })
      .addCase(actionCreators.preModerationById.fulfilled, (state, action) => {
        state[PRE_MODERATION_BY_ID].loading = false
        state[PRE_MODERATION_BY_ID].error = null
        state[PRE_MODERATION_BY_ID].data = action.payload
      })

    builder
      .addCase(actionCreators.preModerationHistoryCreate.pending, state => {
        state[PRE_MODERATION_HISTORY_CREATE].loading = true
      })
      .addCase(actionCreators.preModerationHistoryCreate.rejected, (state, action) => {
        state[PRE_MODERATION_HISTORY_CREATE].loading = false
        state[PRE_MODERATION_HISTORY_CREATE].error = action.payload as AxiosError
      })
      .addCase(actionCreators.preModerationHistoryCreate.fulfilled, (state, action) => {
        state[PRE_MODERATION_HISTORY_CREATE].loading = false
        state[PRE_MODERATION_HISTORY_CREATE].error = null
        state[PRE_MODERATION_HISTORY_CREATE].data = action.payload
      })

    builder
      .addCase(actionCreators.preModerationChangeStatus.pending, state => {
        state[PRE_MODERATION_CHANGE_STATUS].loading = true
      })
      .addCase(actionCreators.preModerationChangeStatus.rejected, (state, action) => {
        state[PRE_MODERATION_CHANGE_STATUS].loading = false
        state[PRE_MODERATION_CHANGE_STATUS].error = action.payload as AxiosError
      })
      .addCase(actionCreators.preModerationChangeStatus.fulfilled, (state, action) => {
        state[PRE_MODERATION_CHANGE_STATUS].loading = false
        state[PRE_MODERATION_CHANGE_STATUS].error = null
        state[PRE_MODERATION_CHANGE_STATUS].data = action.payload
      })

    builder.addCase(actionCreators.preModerationAllClear, state => {
      state[PRE_MODERATION_ALL] = defaultState()
    })

    builder.addCase(actionCreators.preModerationAssignedClear, state => {
      state[PRE_MODERATION_ASSIGNED] = defaultState()
    })

    builder.addCase(actionCreators.preModerationByIdClear, state => {
      state[PRE_MODERATION_BY_ID] = defaultState()
    })
  },
})
